import {Component} from "react";

export class SellToWebTableColumnDropdownComponent extends Component {
}